module.exports = __webpack_public_path__ + "img/feature_buy_en.91f8e2c0.png";